module.exports = __webpack_public_path__ + "img/base_patrimoine_patrimoine_religieux.10b0c063.svg";